import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=5c18148a&scoped=true&functional=true&"
import script from "./badge.vue?vue&type=script&lang=js&"
export * from "./badge.vue?vue&type=script&lang=js&"
import style0 from "./badge.vue?vue&type=style&index=0&id=5c18148a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5c18148a",
  null
  
)

export default component.exports